module.exports = __webpack_public_path__ + "static/media/hand1.e00e1873.png";